import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfferService, OfferOutputDto } from 'src/generated_client';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-discount-management',
  templateUrl: './discount-management.component.html',
  styleUrls: ['./discount-management.component.css']
})

export class DiscountManagementComponent implements OnInit {

  displayedColumns: string[] = ['code', 'value', 'dateCreated', 'status', 'options'];
  dataSource: Array<OfferOutputDto> = [];

  constructor(
    private router: Router,
    private service: OfferService,
    private snack: SnackBarService
  ) { }

  ngOnInit(): void {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.getOffers();
  }

  private getOffers() {
    this.service.apiOfferGetAllOffersGet().subscribe(x => {
      this.dataSource = x;
    },
      err => {
        this.snack.openSnackBar('Ocurrio un problema y no pudo cargarse', 'Aceptar');
      }
    )
  }

  editDiscount(id: number) {
    this.router.navigate(['edit-discount', id]);
  }

  addDiscount() {
    this.router.navigate(['add-discount']);
  }

  enableDisable(id: number, status: boolean) {

    if (status) {

      this.DisableOffer(id);
      this.snack.openSnackBar('Se desactivó el descuento','Acepar')
    }
    else {
      this.EnableOffer(id);
      this.snack.openSnackBar('Se activó el descuento','Acepar')
    }
  }

  deleteDiscount(id: number) {

    this.service.apiOfferDeleteOfferDelete(id).subscribe(() => {

      this.router.navigate(['discount-management']);
      this.snack.openSnackBar('El descuento fue eliminado','Aceptar');
    },

      err => {

        this.snack.openSnackBar(err.error.error, 'Aceptar');
      }
    );
  }

  private EnableOffer(id: number) {
    this.service.apiOfferEnableOfferPut(id).subscribe(() => {

      this.router.navigate(['discount-management']);
    },
      err => {

        this.snack.openSnackBar(err.error.error, 'Aceptar');
      }
    );
  }

  private DisableOffer(id: number) {
    this.service.apiOfferDisableOfferPut(id).subscribe(() => {

      this.router.navigate(['discount-management']);
    },
      err => {

        this.snack.openSnackBar(err.error.error, 'Aceptar');
      }
    );
  }
}
